import { ClipboardCheck } from "lucide-react";
import { usePoll } from "@/hooks/usePoll";
import { PageHeader, Empty } from "@/components/common";
import TicketCard, { useTick } from "@/components/TicketCard";

export default function Checker() {
  const { data, reload } = usePoll("/checker/bills", 5000);
  useTick();
  const rows = data || [];
  return (
    <div>
      <PageHeader title="Dashboard Checker" subtitle="Klik menu yang sudah keluar & diantar ke meja. Klik Selesai jika komplit agar kasir bisa menerima pembayaran">
        <span className="rounded-full bg-purple-100 px-3 py-1 text-sm font-semibold text-purple-800" data-testid="checker-count">{rows.length} bill</span>
      </PageHeader>
      {rows.length === 0 && <Empty icon={ClipboardCheck} text="Tidak ada bill untuk dicek" testId="checker-empty" />}
      <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 xl:grid-cols-3 2xl:grid-cols-4">
        {rows.map((b) => (
          <TicketCard key={b.id} bill={b} prefix="checker"
            isChecked={(i) => i.delivered}
            canToggle={(i) => i.kitchen_ready}
            hint={(i) => (i.kitchen_ready ? "sudah keluar dapur" : "masih dimasak")}
            toggleUrl={(i) => `/bills/${b.id}/items/${i.id}/deliver`}
            doneUrl={`/bills/${b.id}/checker-done`}
            doneLabel="Selesai"
            onChange={reload} />
        ))}
      </div>
    </div>
  );
}
